(function(angular){
  'use strict';

  angular.module('accountingCosts')
         .config(['$stateProvider', function($stateProvider){
           $stateProvider.state('accounting-costs', {
             url: '/costs',
             templateUrl: 'accounting-costs/accounting-costs.html',
             controller: 'accountingCosts.AccountingCostsController as vm',
             resolve: {
               user: ['myAccountService', function(myAccountService){
                 return myAccountService.getMyUserSettingsAsync().then(function(settings){
                   return settings.data;
                 });
               }]
             }
           });
         }]);
})(window.angular);
